import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { CompanyEndpointMethod } from '../../../../quarantine/exchangeProtection/types';
import { GzSingleSelectComplexBaseDataProvider } from '../GzSingleSelectComplexBaseDataProvider';
import { DEFAULT_DATA_LIMIT, GetItemsRequest, GetItemsResponse } from '../../types';

export class CompanyFilterTelemetryExclusionsDataProvider extends GzSingleSelectComplexBaseDataProvider {
  async getItems({ searchValue, page, limit }: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    return this.getItemsDefault({ searchValue, page, limit }, 'search');
  }

  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    return this.getItemsDefault(request, 'initial');
  }

  async getItemsDefault(request: GetItemsRequest, type: string): Promise<GetItemsResponse | undefined> {
    let payload = {};

    switch (type) {
      case 'initial':
        payload = {
          limit: DEFAULT_DATA_LIMIT,
          options: {
            source: 'fromSecurityTelemetry',
          },
        };
        break;
      case 'search':
        payload = {
          page: request.page,
          limit: request.limit,
          companyName: request.searchValue,
          options: {
            source: 'fromSecurityTelemetry',
          },
        };
    }

    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'Company',
        method: CompanyEndpointMethod.GET_AVAILABLE_COMPANIES,
        payload: payload,
      });

      return {
        items: response.data.map(({ _id, name }) => ({ value: _id, label: name })),
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
